import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { DRIP_TEXT_MUTED, DRIP_TRACK_BG } from "./dripStyles";

interface DripWithdrawPercentSelectorProps {
  onSelect: (pct: number) => void;
}

const OPTIONS = [
  { label: "25%", value: 0.25 },
  { label: "50%", value: 0.5 },
  { label: "75%", value: 0.75 },
  { label: "MAX", value: 1 },
];

export const DripWithdrawPercentSelector = ({ onSelect }: DripWithdrawPercentSelectorProps) => (
  <Box
    bg={DRIP_TRACK_BG}
    borderRadius="xl"
    border="1px solid"
    borderColor="whiteAlpha.200"
    p="3px"
    width="100%"
  >
    <Flex gap="3px">
      {OPTIONS.map(({ label, value }) => (
        <Button
          key={label}
          type="button"
          flex={1}
          variant="unstyled"
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="lg"
          py={2}
          px={2}
          minH="36px"
          bg="transparent"
          transition="background 0.2s ease, color 0.2s ease"
          onClick={() => onSelect(value)}
          _hover={{ bg: "whiteAlpha.100" }}
          _focusVisible={{ boxShadow: "0 0 0 2px rgba(95, 244, 244, 0.5)" }}
        >
          <Text fontSize="sm" fontWeight="medium" color={DRIP_TEXT_MUTED}>
            {label}
          </Text>
        </Button>
      ))}
    </Flex>
  </Box>
);
